'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  position: fixed;\n  margin-right: ', ';\n  background: #fff;\n  background-color: #fff;\n  box-shadow: 0 1px 3px #b9c5cd;\n  height: 100%;\n  overflow-x: auto;\n  padding-bottom: 10px;\n  right: 0;\n  transition: margin-right 0.5s;\n  top: 0;\n  ', '\n'], ['\n  ', '\n  position: fixed;\n  margin-right: ', ';\n  background: #fff;\n  background-color: #fff;\n  box-shadow: 0 1px 3px #b9c5cd;\n  height: 100%;\n  overflow-x: auto;\n  padding-bottom: 10px;\n  right: 0;\n  transition: margin-right 0.5s;\n  top: 0;\n  ', '\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.topOffset && '\n    height: calc(100% - ' + props.topOffset + 'px);\n    margin-top: ' + props.topOffset + 'px;\n  ';
}, function (props) {
  return props.open ? '0' : '-' + props.sidebarWidth;
}, function (props) {
  return props.sidebarWidth && 'width: ' + props.sidebarWidth + ';';
});

Wrapper.displayName = 'Wrapper';

exports.default = Wrapper;
//# sourceMappingURL=Wrapper.js.map


//////////////////
// WEBPACK FOOTER
// ../sidebar/lib/Wrapper.js
// module id = 168
// module chunks = 0